import forEach from "lodash/forEach";
import moment from "moment-timezone";

class infoCtrl {
  constructor($scope, $http, $window, $location) {
    $scope.state = "step1";

    $scope.days = [];
    for (let i = 1; i <= 31; i++) {
      $scope.days.push(i);
    }
    $scope.months = [
      { name: "Janvier", value: 1 },
      { name: "Février", value: 2 },
      { name: "Mars", value: 3 },
      { name: "Avril", value: 4 },
      { name: "Mai", value: 5 },
      { name: "Juin", value: 6 },
      { name: "Juillet", value: 7 },
      { name: "Août", value: 8 },
      { name: "Septembre", value: 9 },
      { name: "Octobre", value: 10 },
      { name: "Novembre", value: 11 },
      { name: "Décembre", value: 12 },
    ];

    $scope.years = [];
    for (let j = new Date().getFullYear() - 18; j >= 1915; j--) {
      $scope.years.push(j);
    }

    $scope.renderUISelect = false;

    $scope.info = {
      userLocation: {
        displayName: "",
        googlePlace: null,
        lat: "",
        lng: "",
        city: "",
        country: "",
      },
      birthday: {
        day: "",
        month: "",
        year: "",
      },
      bio: "",
      gender: $scope.gender,
      pastCountries: [],
      nextCountries: [],
      avatar: null,
    };

    $scope.usersAround = {
      total: "?",
      limit: 5,
      city: "____",
      edges: [],
    };

    $scope.usersAgeRange = {
      total: "?",
      limit: 5,
      ageFrom: "__",
      ageTo: "__",
      edges: [],
    };

    $scope.error = {
      userLocation: false,
      birthday: false,
    };

    $window.onbeforeunload = () => "Attention, vos informations ne sont pas encore sauvegardées.";

    $scope.$on("$locationChangeSuccess", () => {
      if ($location.path() === "") {
        $scope.state = "step1";
      } else if ($location.path() === "/etape2") {
        $scope.renderUISelect = true;
        $scope.state = "step2";
      } else if ($location.path() === "/confirmed") {
        $scope.state = "step3";
      }
    });

    $scope.show = (panel) => panel === $scope.state;

    $scope.$on("GMAP_AUTOCOMPLETE.CHANGED", () => {
      $scope.error.userLocation = false;
      $scope.usersAround.total = "?";
      $scope.usersAround.edges = [];
      $scope.usersAround.city = $scope.info.userLocation.city;
      $http
        .get("/api/users/discover/nearby", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.apiToken}`,
          },
          params: {
            lat: $scope.info.userLocation.lat,
            lng: $scope.info.userLocation.lng,
          },
        })
        .then((response) => {
          $scope.usersAround = response.data.users;
          $scope.usersAround.city = $scope.info.userLocation.city;
        });
    });

    $scope.computeBirthday = (day, month, year) => {
      $scope.info.birthday = {
        day: day,
        month: month,
        year: year,
      };
      $scope.updateBirthday();
    };

    $scope.calculateAge = () => {
      const birthday = new Date($scope.info.birthday.year, $scope.info.birthday.month, $scope.info.birthday.day);
      const ageDifMs = Date.now() - birthday.getTime();
      const ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    };

    $scope.updateBirthday = () => {
      if ($scope.info.birthday.day && $scope.info.birthday.month && $scope.info.birthday.year) {
        $scope.error.birthday = false;
        $scope.usersAgeRange.total = "?";
        $scope.usersAgeRange.edges = [];
        let currentAge = $scope.calculateAge();
        $scope.usersAgeRange.ageFrom = currentAge - 5;
        $scope.usersAgeRange.ageTo = currentAge + 5;

        $http
          .get("/api/users/discover/same-age", {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${window.apiToken}`,
            },
            params: {
              birthday: new Date($scope.info.birthday.year, $scope.info.birthday.month, $scope.info.birthday.day),
            },
          })
          .then((response) => {
            $scope.usersAgeRange.total = response.data.users.total;
            $scope.usersAgeRange.limit = response.data.users.limit;
            $scope.usersAgeRange.edges = response.data.users.edges;
          });
      }
    };

    $scope.isValidBirthday = () => {
      if (!$scope.info.birthday.day || !$scope.info.birthday.month || !$scope.info.birthday.year) {
        return false;
      }

      const birthday = `${$scope.info.birthday.day}-${$scope.info.birthday.month}-${$scope.info.birthday.year}`;
      return moment(birthday, ["D-M-YYYY"], true).isValid();
    };

    $scope.isStep1Incomplete = () => {
      let response = false;

      if ($scope.info.userLocation.googlePlace === null) {
        $scope.error.userLocation = true;
        response = true;
      }

      if ($scope.isValidBirthday() !== true) {
        $scope.error.birthday = true;
        response = true;
      }

      return response;
    };

    $scope.nextClicked = () => {
      // if (!$scope.isStep1Incomplete()) {  // on ne veut plus forcer l'utilisateur à entrer ses infos de location et age
      $scope.renderUISelect = true;
      $location.url("/etape2");
      // }
    };

    $scope.submitData = () => {
      $window.onbeforeunload = null;

      const info = $scope.info;

      let pastCountriesIds = [];
      forEach(info.pastCountries, (obj) => {
        pastCountriesIds.push(obj.id);
      });

      let nextCountriesIds = [];
      forEach(info.nextCountries, (obj) => {
        nextCountriesIds.push(obj.id);
      });

      info.pastCountries = pastCountriesIds;
      info.nextCountries = nextCountriesIds;

      const response = $http.patch("/api/me/info", angular.toJson(info), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.apiToken}`,
        },
      });

      // display in progress step
      $location.url("/confirmed");

      // redirect on response
      response.then(
        () => {
          $window.location = "/postregistration/confirmed";
        },
        () => {
          window.alert(
            "Nous ne pouvons pas sauvegarder vos informations. Notre équipe a été prévenue. Vous pouvez continuer à naviguer sur notre site."
          );
          $window.location = "/postregistration/confirmed";
        }
      );
    };
  }
}

infoCtrl.$inject = ["$scope", "$http", "$window", "$location"];
export default infoCtrl;
